/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Grid } from '@mui/system';
import Layout from '../../layout';
import { useFetchGraphQL } from '../../hooks';
import GET_CONTACT_US from '../../query/contactUs';
import './contact.scss';
import PageLoader from '../../components/PageLoader/PageLoader';
import HeroSection from './sections/HeroSection';
import ContactInfo from './sections/ContactInfo';
import ScheduleAppointment from './sections/ScheduleAppointment/ScheduleAppointment';
import LocationGallery from './sections/LocationGallery/LocationGallery';
import ContactForm from './sections/ContactForm';

function ContactUs() {
  const { loading, error, data } = useFetchGraphQL(GET_CONTACT_US);

  if (loading) return <PageLoader />;
  if (error) return <p>Error! {error.message}</p>;

  // Validate if contact page data exists
  if (!data?.contactUsPage?.dynamic) {
    console.error('Contact page data is missing');
    return <p>Error loading page content</p>;
  }

  const { dynamic: contactUsPage } = data?.contactUsPage;

  // Validation helper function
  const isValidSection = (section) => section && Object.keys(section).length > 0;

  // Render a section based on its type
  const renderSection = (block) => {
    // eslint-disable-next-line no-underscore-dangle
    const blockType = block.__typename;

    switch (blockType) {
      case 'ComponentHeroContactUsHeroContactUs':
        return isValidSection(block) && (
          <HeroSection heroSection={block} />
        );
      case 'ComponentContactUsConnectExperts':
        return isValidSection(block) && (
          <ContactForm contactExperts={block} />
        );
      case 'ComponentContactUsContactInfo':
        return isValidSection(block) && (
          <ContactInfo contactInfo={block} />
        );
      case 'ComponentContactUsScheduleSection':
        return isValidSection(block) && (
          <ScheduleAppointment scheduleSection={block} />
        );
      case 'ComponentContactUsLocationSliderList':
        return isValidSection(block) && (
          <LocationGallery locationSection={block} />
        );
      default:
        return null;
    }
  };

  return (
    <Layout>
      <Grid className="contactus-wrap">
        {/* Render sections in the order they appear in the GraphQL response */}
        {contactUsPage?.map((block, index) => (
          <React.Fragment key={`block-${index}`}>
            {renderSection(block)}
          </React.Fragment>
        ))}

        {/* Toaster notification */}

      </Grid>
    </Layout>
  );
}

export default ContactUs;
